// Shared Google Maps loader configuration
// All components must use this exact configuration to avoid loader conflicts

export const googleMapsLoaderConfig = {
  id: 'google-map-script',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  libraries: ['maps', 'places', 'geometry'],
  // Note: preventGoogleFontsLoading is optional and can vary per component
  // but libraries array MUST be consistent across all components
};

